var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgView(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5896 5.68278C12.6274 6.45611 13.3877 7.54393 13.7574 8.78428L13.846 8.75788L15.0991 8.38445L15.1877 8.35805C15.0528 7.90541 14.8762 7.46905 14.6615 7.054C14.1417 6.04915 13.3983 5.16928 12.4813 4.48603C11.1857 3.52058 9.6129 2.99937 7.99711 3C6.38131 3.00063 4.80892 3.52306 3.51403 4.48952C2.59764 5.17348 1.85491 6.05394 1.33587 7.05919C1.12149 7.4744 0.945266 7.9109 0.81073 8.36364L0.899354 8.38998L2.15273 8.76243L2.24136 8.78877C2.61002 7.54812 3.3695 6.45971 4.40672 5.68557C5.44393 4.91143 6.70343 4.49296 7.99769 4.49246C9.29195 4.49195 10.5518 4.90944 11.5896 5.68278ZM8.00003 12C9.65688 12 11 10.6569 11 9C11 7.34315 9.65688 6 8.00003 6C6.34317 6 5.00003 7.34315 5.00003 9C5.00003 10.6569 6.34317 12 8.00003 12Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.5aedc36d.svg";
export { ForwardRef as ReactComponent };